/* global axios */

// Capture the full scope before awaiting. ApiClient's account-scoped URL can
// otherwise change while the agent moves between accounts.
export async function requestMessageTranslation({
  accountId,
  conversationId,
  messageId,
}) {
  const ids = [accountId, conversationId, messageId].map(Number);
  if (!ids.every(value => Number.isSafeInteger(value) && value > 0)) {
    throw new Error('Invalid translation scope');
  }
  const [account, conversation, message] = ids;
  const response = await axios.post(
    `/api/v1/accounts/${account}/conversations/${conversation}/messages/${message}/translate`,
    { manual: true }
  );
  return response.data;
}

// Chinese display: queue background translations; results arrive as message updates.
export async function requestMissingTranslations({
  accountId,
  conversationId,
  messageIds,
}) {
  const scope = [accountId, conversationId].map(Number);
  const ids = messageIds.map(Number);
  if (![...scope, ...ids].every(value => Number.isSafeInteger(value) && value > 0)) {
    throw new Error('Invalid translation scope');
  }
  const response = await axios.post(
    `/api/v1/accounts/${scope[0]}/conversations/${scope[1]}/messages/translate_missing`,
    { message_ids: ids }
  );
  return response.data;
}
